import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import {ItemSummaryEventService} from './item-summary-event.service';
import {appConfig} from '../app.config';
import {AuctionEvent} from '../domain/auction-event';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ItemSummaryEventServiceImpl extends ItemSummaryEventService {

  constructor(private http: HttpClient) {
    super();
  }

  getRbAuctionEvents(days: number): void {
    if (!days) {
      days = appConfig.defaultNumberOfDaysToGoBackForGettingAuctionEvents;
    }
    const url =  '/api/auction-events/rb?numberOfDaysToGoBack=' + days;

    this.http.get(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getAuctionEventList', []))
      )
      .subscribe(response => {
        this.data.rbAuctionEvents = response as AuctionEvent[];
        this.rbAuctionEventListCallback.next(this.data.rbAuctionEvents);
      });
  }

  getAuctionEventDetails(auctionEventId: number): void {
    let url =  '/api/auction-events/:auctionEventId';
    url = url.replace(':auctionEventId', String(auctionEventId));
    this.getAuctionEventDetailsObservable(auctionEventId)
      .subscribe(response => {
        if (response && response.auctionEventDto) {
          this.auctionEventCallback.next(response.auctionEventDto as AuctionEvent);
        }
      });
  }

  getAuctionEventDetailsObservable(auctionEventId: number): Observable<any> {
    let url =  '/api/auction-events/:auctionEventId';
    url = url.replace(':auctionEventId', String(auctionEventId));
    return this.http.get(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getAuctionEventDetails', null))
      );
  }
}
